// store.ts
import { useStorage, createGlobalState } from '@vueuse/core';
import {
  shallowRef,
  computed,
  readonly,
  reactive,
  ref,
  shallowReactive,
  shallowReadonly,
} from 'vue';
import { UAParser } from 'ua-parser-js';
const parser = new UAParser();
const lazy_image = useStorage('supportLazyImage', '');
// 判断是否支持懒加载
if (!lazy_image.value) {
  let testImg = document.createElement('img');
  if ('loading' in testImg) {
    lazy_image.value = 'true';
  } else {
    lazy_image.value = 'false';
  }
}

// 每次活动都会用到的状态
export const useStore = createGlobalState(() => {
  // 渠道标识
  const channel = shallowReactive({
    utm_source: 'gw',
    extra: 'gw',
    channel: 'h5',
  });
  function set_utm_source(v) {
    channel.utm_source = v;
  }

  function set_extra(v) {
    channel.extra = v;
  }

  function set_channel(v) {
    channel.channel = v;
  }

  // 小程序token
  const mini_token = shallowRef('');
  function set_mini_token(v) {
    mini_token.value = v;
  }

  //   端游扫码登录
  const scan_token = shallowRef('');
  function set_scan_token(v) {
    scan_token.value = v;
  }

  const share_id = ref('');
  function set_share_id(v) {
    share_id.value = v;
  }

  // 浏览器设备信息
  const uaResult = parser.getResult();
  const ua_info = {
    browser: {
      name: uaResult.browser.name,
      version: uaResult.browser.version,
      major: uaResult.browser.major,
    },
    os: {
      name: uaResult.os.name,
      version: uaResult.os.version,
    },
    device: {
      model: uaResult.device.model,
      type: uaResult.device.type, // 'mobile', 'tablet', 'desktop', 'tv', etc.
      vendor: uaResult.device.vendor,
    },
    engine: {
      name: uaResult.engine.name,
      version: uaResult.engine.version,
    },
    cpu: {
      architecture: uaResult.cpu.architecture,
    },
    userAgent: navigator.userAgent,
  };

  const is_mobile = computed(() => {
    return uaResult.device.type === 'mobile' ? true : false;
  });

  const browser = shallowRef(parser.getBrowser().name);
  // 是否支持图片懒加载
  const support_lazy_image = shallowRef(lazy_image.value);

  // 支持的图片格式
  const support_image = useStorage('supportImg', 'png');

  let user = ref({});
  function set_user(data) {
    user.value = {...data};
  }
  return {
    share_id,
    channel: readonly(channel),
    ua_info,
    support_lazy_image: shallowReadonly(support_lazy_image),
    set_utm_source,
    set_extra,
    set_channel,
    set_mini_token,
    set_share_id,
    set_scan_token,
    scan_token: shallowReadonly(scan_token),
    mini_token: shallowReadonly(mini_token),
    browser: shallowReadonly(browser),
    is_mobile: readonly(is_mobile),
    support_image: readonly(support_image),
    user: readonly(user),
    set_user,
  };
});

// 单次活动需要定义的全局变量:这里是每次都变的
export const useData = createGlobalState(() => {
  const is_login = shallowRef(false);

  const is_bind = computed(() => {
    return true;
  });
  //   应该是一个根据其他数据算出来的变量
  let init_data = reactive({});
  let copy_link = ref('');

  function set_init_data(v) {
    Object.assign(init_data, v);
  }
  function set_login_status(data) {
    is_login.value = data;
  }

  function set_copy_link(data) {
    copy_link.value = data;
  }

  function clear_init_data() {
    for (const key in init_data) {
      delete init_data[key];
    }
  }

  const conf = reactive({});
  function set_conf(data) {
    Object.assign(conf, data);
  }

  return {
    is_login,
    is_bind,
    init_data: readonly(init_data),
    set_init_data,
    clear_init_data,
    set_login_status,
    copy_link,
    set_copy_link,
    conf,
    set_conf,
  };
});
